import { DynamIQLogo } from '../Icons';
import { Footer } from '../LoggedLayout/components';
import { Spinner } from '../Spinner';

export default function LoadingPage() {
  return (
    <div className="flex h-full flex-col justify-between bg-gradient">
      <div className="pl-5 pt-5 text-white">
        <DynamIQLogo />
      </div>
      <div className="flex flex-1 items-center justify-center">
        <div className="flex h-full justify-center">
          <Spinner />
        </div>
      </div>
      <Footer />
    </div>
  );
}
